<template>
        <b-button  class='card-challenges-event'>
          <b-card header-tag="header" footer-tag="footer">


            <template v-slot:header class="d-flex">
              <div class="title">
              <h5>
                <PuSkeleton :loading="isLoading" :count="1" width='120px' height="20px">                
                  {{title}}
                </PuSkeleton>
              </h5>
              </div>
              <i class="fal fa-edit"></i>
            </template>



            <b-card-text>
              <div class="left">

                <div class="top">
                  <PuSkeleton :loading="isLoading" :count="1" width="200px">
                    <span>
                      <i class="far fa-calendar-alt"></i>
                      <div class="title">{{content.labelStart}}</div>
                    </span>
                    <div class="date">{{startDate}}</div>
                  </PuSkeleton>
                </div>


                <div class="bottom">
                  <PuSkeleton :loading="isLoading" :count="1" width="200px">
                    <span>
                      <i class="far fa-calendar-alt"></i>
                      <div class="title">{{content.labelEnd}}</div>
                    </span>
                    <div class="date">{{endDate}}</div>   
                  </PuSkeleton>
                </div>

              </div>

              <div class="right">
                <PuSkeleton :loading="isLoading" :count="1" width="120px">                                  
                  <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
                  <div class="cible">
                    <p class="title">Objectif</p>
                    <div class="number">{{objectiveNumber}}</div>
                  </div>
                </PuSkeleton>
              </div>

            </b-card-text>



              <div class="line">
                <p class="inprogress">
                  <PuSkeleton :loading="isLoading" :count="1" width="120px">                  
                    {{inprogress}}
                  </PuSkeleton>  
                </p>
                <PuSkeleton :loading="isLoading" :count="1">
                  <b-progress height="0.5625rem" :value="50">
                  </b-progress>
                </PuSkeleton>
              </div>         

            <template v-slot:footer>
              <div class="deadline">
                <PuSkeleton :loading="isLoading" :count="1" width="100px" height="25px">                
                  {{content.dayOf}}{{deadline}}
                </PuSkeleton>
              </div>
              <div class="state">
                <PuSkeleton :loading="isLoading" :count="1" width="100px" height="25px">                
                  {{state}}
                </PuSkeleton>
              </div>   
            </template>

          </b-card>
        </b-button>

</template>


<script>
import { mapGetters } from 'vuex'
//
export default {
  name: "CardChallengesDate",
  components:{ 
  },
  props:{
    title:{
      type:String,
      default:'Pura Vida'
    },
    objectiveNumber:{
      type:String,
      default:'110 000'
    },
    startDate:{
      type:String,
      default:'04/04/2020'
    },
    endDate:{
      type:String,
      default:'04/05/2020'
    },
    inprogress:{
      type:String,
      default:'56 000'
    },
    deadline:{
      type:String,
      default:'45'
    },
    state:{
      type:String,
      default:'en cours'
    },

  },
  data(){
    return {  
      content:{},   
      isLoading:true,
    }
  },
  computed: {
    ...mapGetters([
      'getGeneral',
    ]),
  },
  created (){
    this.content = this.getGeneral;
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)       
  }
}
</script>